import Vue from 'vue';
export default Vue.extend({
    props: {
        borderCornerSize: {
            type: String,
            default: '5px',
        },
        borderWidth: {
            type: String,
            default: '1px',
        }
    },
    computed: {
        cssVars() {
            return {
                '--border-corner-size': this.borderCornerSize,
                '--border-width': this.borderWidth,
            };
        }
    }
});
